export default {
  login: "auth/login",
  passwordReset: "auth/password-reset",
  CHANGE_PASSWORD: "auth/change-password",
  password: "auth/password",
  logout: "auth/logout",
  user: `auth/user`,
  setCompany: `auth/set-company`,
  APPLICATION_REGISTRATION: `applications/signup`,
  REQUEST_CREDENTIALS: `auth/request-credentials`,
  VERIFY_ACCOUNT: `auth/verify`,
};
